import payApi from '../../api/pay.api'
import vipApi from '../../api/vip'
const state = {
};

const getters = {
};

const mutations = {
};

const actions = {
    //支付
    payVip({commit},params) {
        return payApi.payVip(params)
    },
    //检测是否支付
    isCompleteVipPay({commit},params) {
        return payApi.isCompleteVipPay(params)
    },
    //获取会员价格
    getVipPrice({commit},params) {
        return vipApi.getVipPrice(params)
    },

};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};



// WEBPACK FOOTER //
// ./app/store/modules/vip.js